import React, { useCallback, useEffect, useState, useContext } from 'react';
import LayoutContainer from 'components/layout/LayoutContainer';
import AdminHeader from 'components/header/index';
import Card from 'components/inputs/Card';
import SessionHeading from 'components/general/SessionHeading';
import { Row, Col, Spinner, Modal } from 'react-bootstrap';
import TextInput from 'components/inputs/Input';
import Select from 'components/inputs/Select';
import Button from 'components/inputs/Button';
import * as _ from 'lodash';
import { Formik, Form, FieldArray } from 'formik';
import { CREATE_CHARGER, UPDATE_CHARGER, GET_CHARGER } from 'actions/charger';
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';
import { useParams } from 'react-router-dom';
import { FETCH_CHARGING_STATION } from 'actions/chargingStation';
import { FETCH_OEM } from 'actions/oem';
import { FETCH_TARIFF } from 'actions/tariff';
import CheckBox from 'components/inputs/CheckBox';
import { FETCH_CHARGE_SPEED } from 'actions/chargeSpeed';
import { FETCH_OEM_VENDOR } from 'actions/oemVendor';
import DatePickerInput from 'components/inputs/DatePickerInput';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import Footer from 'components/general/Footer';
import { GET_ADD_ONS, GET_STATION_CHARGERS, MANAGE_ADD_ONS, MANAGE_STATION_CHARGERS, UPDATE_STATUS_CODE } from 'components/common/constant';
import { NavContext } from 'components/privateRoute/PrivateRoute';
import { FETCH_OWNERSHIP_TYPE } from 'actions/ownershipType';
import { IoCellular, IoWifi, IoGlobe, IoServer } from 'react-icons/io5';
import { MdOutlineSatelliteAlt } from 'react-icons/md';
import toast from 'react-hot-toast';

const ChargerForm = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { chargerId } = useParams();
  const { navigateTo } = useContext(NavContext);
  const queryParams = new URLSearchParams(window.location.search);
  const chargingStationId = queryParams.get('station');

  const allStations = useSelector((state) => state.chargingStation.chargingStations);
  const allOems = useSelector((state) => state.oem.oems);
  const ownershipTypeList = useSelector((state) => state.ownershipType.ownershipTypes);
  const allOemVendor = useSelector((state) => state.oemVendor.oemVendors);
  const allChargerSpeed = useSelector((state) => state.chargeSpeed.chargeSpeed);
  // const isLoading = useSelector((state) => state.charger.isLoading);
  const chargerDetail = useSelector((state) => state.charger.chargerDetails);
  const allTariffList = useSelector((state) => state.tariff.tariff);
  const profileDetail = useSelector((state) => state.profile.userProfile);
  const tenantId = _.get(profileDetail, 'tenant.id', '');
  const currentUserName = _.get(profileDetail, 'name', '');
  const supportApp = _.get(profileDetail, 'tenant.support_cz_app_booking', '');
  const oemPage = useSelector((state) => state.oemVendor.page);
  const tariffPage = useSelector((state) => state.tariff.page);
  const ownershipTypePage = useSelector((state) => state.ownershipType.page);
  const oemTotalPage = useSelector((state) => state.oemVendor.totalPages);
  const tariffTotalPage = useSelector((state) => state.tariff.totalPages);
  const ownershipTypeTotalPage = useSelector((state) => state.ownershipType.totalPages);
  // const [generateChargerId, setGenerateChargerId] = useState('');
  const [isDraft, setDraft] = useState(false);
  const [showDecommissionModal, setShowDecommissionModal] = useState(false);
  const [pendingValues, setPendingValues] = useState(null);
  const [pendingSetSubmitting, setPendingSetSubmitting] = useState(null);
  const [decommissionedByText, setDecommissionedByText] = useState('');
  const [activeTab, setActiveTab] = useState('basic');
  // Snapshot of initial values to compute diff for PATCH
  const [initialSnapshot, setInitialSnapshot] = useState(null);

  const hasTabError = useCallback((tabId, errors) => {
    const isError = (fieldName) => {
      return !!_.get(errors, fieldName);
    };

    if (tabId === 'basic') {
      return !!(
        isError('charging_station') ||
        isError('charger_id') ||
        isError('oem_vendor') ||
        isError('oem') ||
        isError('tariff') ||
        isError('charging_speed') ||
        isError('custom_rating') ||
        isError('ownership_type') ||
        isError('maintenance_type') ||
        isError('maintenance_remarks')
      );
    }
    if (tabId === 'power') {
      return !!(
        isError('charging_system_type') ||
        isError('oem_charger_type') ||
        isError('dispenser_capacity_kw') ||
        isError('output_power_limit_kw') ||
        isError('onboarded_on_cms_by')
      );
    }
    if (tabId === 'warranty') {
      return !!(
        isError('warranty_period_years') ||
        isError('warranty_expired_date') ||
        isError('warranty_status') ||
        isError('amc_start_date') ||
        isError('amc_done_period_years') ||
        isError('amc_expired_date') ||
        isError('amc_status')
      );
    }
    if (tabId === 'connectivity') {
      return !!(
        isError('decommissioned_on') ||
        isError('decommissioned_by') ||
        isError('comments')
      );
    }
    return false;
  }, []);

  const getTabStyle = useCallback((tabId, errors) => {
    const hasError = hasTabError(tabId, errors);
    if (hasError) {
      if (activeTab === tabId) {
        return {
          color: '#ffffff',
          backgroundColor: '#dc4949',
          border: '1px solid #dc4949',
        };
      } else {
        return {
          color: '#dc4949',
          border: '1px solid #dc4949',
          backgroundColor: 'rgba(220, 73, 73, 0.08)',
        };
      }
    }
    return {};
  }, [activeTab, hasTabError]);

  const maintenanceTypes = [
    { label: 'Charger Breakdown', value: 'Charger Breakdown' },
    { label: 'Station Electrical Breakdown', value: 'Station Electrical Breakdown' },
    { label: 'Preventive Maintenance', value: 'Preventive Maintenance' },
    { label: 'Non-Operational', value: 'Non-Operational' },
  ];

  const editChargerDetail = useCallback(
    (data, callback) =>
      dispatch({
        type: UPDATE_CHARGER.REQUEST,
        payload: data,
        cb: (res) => {
          if (_.get(res, 'status') === UPDATE_STATUS_CODE) {
            setTimeout(() => {
              navigateTo(`/charger/${chargerId}`);
            }, 1000);
          }
          if (callback) callback(res);
        },
      }),
    [chargerId]
  );

  const rolePermissionData = useSelector((state) => state.manageRole.manageRoles);

  const getChargerDetail = useCallback((id) => {
    dispatch({ type: GET_CHARGER.REQUEST, payload: id });
  }, []);

  const getAllChargerSpeed = useCallback(() => dispatch({ type: FETCH_CHARGE_SPEED.REQUEST }), []);

  const getChargeSpotByOem = useCallback((id = '') => {
    dispatch({ type: FETCH_OEM.REQUEST, payload: { vendor: id, limit: 999 } });
  }, []);

  const getTariffByChargeSpot = useCallback((data = {}) => {
    dispatch({ type: FETCH_TARIFF.REQUEST, payload: data });
  }, []);

  const getChargingStations = useCallback(() => {
    const data = {
      request_all: true,
    };
    dispatch({ type: FETCH_CHARGING_STATION.REQUEST, payload: data });
  }, []);

  const getOemVendor = useCallback((data = {}) => {
    dispatch({ type: FETCH_OEM_VENDOR.REQUEST, payload: data });
  }, []);

  const getOwnershipType = useCallback((data = {}) => {
    dispatch({ type: FETCH_OWNERSHIP_TYPE.REQUEST, payload: data });
  }, []);

  const getAddOns =
    !_.isEmpty(rolePermissionData) &&
    _.map(
      _.filter(rolePermissionData[0].permissions, (item) => item.name === GET_ADD_ONS),
      (data) => data.name
    );

  const manageAddOns =
    !_.isEmpty(rolePermissionData) &&
    _.map(
      _.filter(rolePermissionData[0].permissions, (item) => item.name === MANAGE_ADD_ONS),
      (data) => data.name
    );

  const manageStationCharger =
    !_.isEmpty(rolePermissionData) &&
    _.map(
      _.filter(rolePermissionData[0].permissions, (item) => item.name === MANAGE_STATION_CHARGERS),
      (data) => data.name
    );

  const getStationCharger =
    !_.isEmpty(rolePermissionData) &&
    _.map(
      _.filter(rolePermissionData[0].permissions, (item) => item.name === GET_STATION_CHARGERS),
      (data) => data.name
    );

  useEffect(() => {
    getOemVendor({ limit: 999 });
    getAllChargerSpeed();
    getChargingStations();
    getOwnershipType({ limit: 999 });
  }, []);

  useEffect(() => {
    if (chargerId) {
      getChargerDetail(chargerId);
    }
    if (chargerId && !_.isEmpty(chargerDetail)) {
      getChargeSpotByOem(_.get(chargerDetail, 'oem.vendor.id'));
      getTariffByChargeSpot({ oem: _.get(chargerDetail, 'oem.id'), limit: 999 });
    }
  }, [chargerId, _.isEmpty(chargerDetail) && chargerDetail]);

  // Capture a deep snapshot of initialValues once chargerDetail is loaded (for edit diff)
  useEffect(() => {
    if (chargerId && !_.isEmpty(chargerDetail) && !initialSnapshot) {
      const snapshot = _.cloneDeep(initialValues);
      sanitizePayload(snapshot);
      setInitialSnapshot(snapshot);
    }
  }, [chargerId, chargerDetail]);

  const ChargerSchema = Yup.object({
    charger_id: Yup.string().required(t('chargerForm.chargerId')).strict(true).trim(t('chargerForm.space')),
    oem_vendor: Yup.string().required(t('chargerForm.oemVendor')),
    oem: Yup.string().required(t('chargerForm.oem')),
    charging_station: Yup.string().required(t('chargerForm.chargingStation')).strict(true).trim(t('chargerForm.space')),
    tariff: Yup.string().required(t('chargerForm.tariff')),
    serial_number: Yup.string(),
    charging_speed: Yup.string().required(t('chargerForm.chargingSpeed')),
    custom_rating: Yup.number().nullable().positive('Custom Rating must be a positive number').typeError('Custom Rating must be a number'),
    maintenance_type: Yup.string().when('operational_status', {
      is: 'UnderMaintenance',
      then: Yup.string().required('Maintenance type is required when operational status is Under Maintenance'),
      otherwise: Yup.string().nullable(),
    }),
    maintenance_remarks: Yup.string().when('operational_status', {
      is: 'UnderMaintenance',
      then: Yup.string().required('Maintenance remarks is required when operational status is Under Maintenance'),
      otherwise: Yup.string().nullable(),
    }),
  });
  const defaultConnectivity = {
    connection_type: [],
    sim: [],
    supports_dual_sim: false,
    wifi: { ssid: '', password: '' },
    broadband: { network_provider: '', ssid: '', password: '' },
    lan: { ip_config: '' },
    vsat: { provider: '', terminal_id: '' },
  };

  const initialValues = chargerId
    ? {
      ...chargerDetail,
      charging_station: _.get(chargerDetail, 'charging_station.id', ''),
      oem: _.get(chargerDetail, 'oem.id', ''),
      oem_vendor: _.get(chargerDetail, 'oem.vendor.id', ''),
      tariff: _.get(chargerDetail, 'tarrif.id', ''),
      charger_id: _.get(chargerDetail, 'charger_id', ''),
      installation_date: chargerDetail.installation_date ? moment(_.get(chargerDetail, 'installation_date')).format('YYYY-MM-DD') : '',
      go_live_date: chargerDetail.go_live_date ? moment(_.get(chargerDetail, 'go_live_date')).format('YYYY-MM-DD') : '',
      ownership_type: _.get(chargerDetail, 'ownership_type', ''),
      charger_status: _.get(chargerDetail, 'charger_status', ''),
      operational_status: _.get(chargerDetail, 'operational_status', 'Active'), // Ensure operational_status is included
      maintenance_type: _.get(chargerDetail, 'maintenance_type', ''),
      maintenance_remarks: _.get(chargerDetail, 'maintenance_remarks', ''),
      plugs: _.map(_.get(chargerDetail, 'plugs', []), (item) => {
        return {
          ...item,
          name: _.get(item, 'name'),
          connector_id: _.get(item, 'connector_id'),
          tarrif: _.get(item, 'tarrif.id'),
        };
      }),
      charging_speed: _.get(chargerDetail, 'charging_speed', ''),
      custom_rating: _.get(chargerDetail, 'custom_rating', ''),
      charger_power_limit: _.get(chargerDetail, 'charger_power_limit', ''),
      does_support_load_balancing: _.get(chargerDetail, 'does_support_load_balancing', false),
      // New fields â€“ edit mode
      charging_system_type: _.get(chargerDetail, 'charging_system_type', ''),
      dispenser_capacity_kw: _.get(chargerDetail, 'dispenser_capacity_kw', ''),
      output_power_limit_kw: _.get(chargerDetail, 'output_power_limit_kw', ''),
      onboarded_on_cms_by: _.get(chargerDetail, 'onboarded_on_cms_by', ''),
      warranty_period_years: _.get(chargerDetail, 'warranty_period_years', ''),
      warranty_expired_date: chargerDetail.warranty_expired_date ? moment(_.get(chargerDetail, 'warranty_expired_date')).format('YYYY-MM-DD') : '',
      warranty_status: _.get(chargerDetail, 'warranty_status', ''),
      amc_start_date: chargerDetail.amc_start_date ? moment(_.get(chargerDetail, 'amc_start_date')).format('YYYY-MM-DD') : '',
      amc_done_period_years: _.get(chargerDetail, 'amc_done_period_years', ''),
      amc_expired_date: chargerDetail.amc_expired_date ? moment(_.get(chargerDetail, 'amc_expired_date')).format('YYYY-MM-DD') : '',
      amc_status: _.get(chargerDetail, 'amc_status', ''),
      oem_charger_type: _.get(chargerDetail, 'oem_charger_type', ''),
      decommissioned_on: chargerDetail.decommissioned_on ? moment(_.get(chargerDetail, 'decommissioned_on')).format('YYYY-MM-DD') : '',
      decommissioned_by: _.get(chargerDetail, 'decommissioned_by', ''),
      connectivity: _.get(chargerDetail, 'connectivity')
        ? {
          ..._.get(chargerDetail, 'connectivity'),
          connection_type: Array.isArray(_.get(chargerDetail, 'connectivity.connection_type'))
            ? _.get(chargerDetail, 'connectivity.connection_type')
            : _.get(chargerDetail, 'connectivity.connection_type') ? [_.get(chargerDetail, 'connectivity.connection_type')] : [],
        }
        : defaultConnectivity,
    }
    : {
      description: '',
      charger_id: '',
      oem: '',
      plugs: [],
      is_active: true,
      tenant: '',
      installation_date: '',
      charging_station: chargingStationId ? _.get(_.find(allStations, { id: chargingStationId }), 'id', '') : '',
      timing_type: 'custom',
      parking_restrictions: false,
      is_superfast_mode_supported: false,
      is_duplicate_transaction_mode_supported: false,
      is_ping_pong_supported: false,
      auto_charge_supported: false,
      otp_verification: false,
      rfid_verification: false,
      wss_supported: false,
      is_chargecoin_disabled: _.get(_.find(allStations, { id: chargingStationId }), 'is_chargecoin_disabled', ''),
      comments: '',
      cooldown_time: '',
      charger_status: '',
      charging_speed: '',
      oem_vendor: '',
      tariff: '',
      serial_number: '',
      load_limit: '',
      maintenance_type: '',
      maintenance_remarks: '',
      settings: {
        ocpp_details: {},
        current_firmware: '1.1',
      },
      custom_rating: '',
      charger_power_limit: '',
      does_support_load_balancing: false,
      // New fields â€“ create mode defaults
      charging_system_type: '',
      dispenser_capacity_kw: '',
      output_power_limit_kw: '',
      onboarded_on_cms_by: '',
      warranty_period_years: '',
      warranty_expired_date: '',
      warranty_status: '',
      amc_start_date: '',
      amc_done_period_years: '',
      amc_expired_date: '',
      amc_status: '',
      oem_charger_type: '',
      decommissioned_on: '',
      decommissioned_by: '',
      connectivity: defaultConnectivity,
    };

  const addCharger = useCallback(
    (data, callback) => {
      dispatch({
        type: CREATE_CHARGER.REQUEST,
        payload: { ...data, tenant: tenantId },
        cb: (res) => {
          if (_.get(res, 'status') === UPDATE_STATUS_CODE) {
            const targetStationId = data.charging_station || chargingStationId;
            if (targetStationId) {
              setTimeout(() => {
                navigateTo(`/stations/${targetStationId}`);
              }, 1000);
            } else {
              setTimeout(() => {
                navigateTo('/stations');
              }, 1000);
            }
          }
          if (callback) callback(res);
        },
      });
    },
    [chargingStationId, tenantId]
  );

  // ── Field-type definitions for payload sanitization ──
  // Mongoose enum fields: accept null but NOT '' — convert '' → null
  const enumFields = [
    'charging_system_type', 'warranty_status', 'amc_status',
    'maintenance_type',
  ];
  // Joi number fields: accept null but NOT '' — convert '' → null, valid values → Number()
  const numberFields = [
    'custom_rating', 'dispenser_capacity_kw', 'output_power_limit_kw',
    'charger_power_limit', 'warranty_period_years', 'amc_done_period_years',
  ];
  // Joi date fields: accept null but NOT '' — convert '' → null
  const dateFields = [
    'installation_date', 'go_live_date', 'warranty_expired_date',
    'amc_start_date', 'amc_expired_date', 'decommissioned_on',
  ];

  // Fields to always exclude from PATCH payload (read-only / server-managed)
  const fieldsToOmit = [
    'settings', 'timings', 'id', 'is_errored', 'old_status',
    'is_auth_supported', 'oem_vendor', 'tariff', 'ocpp_url',
    'last_active', 'tenant', 'createdAt', 'updatedAt',
    'times_sent_trigger', 'is_external_charger', 'external_evse_id',
    'ocpiCredential', 'is_auto_charge_supported', 'last_session_happened',
    'region', 'lastStatusUpdatedAt', 'external_evse_images',
    'is_decommission_confirmed', 'decommissioned_by_temp',
  ];

  /**
   * Sanitize payload values to match backend Mongoose / Joi expectations.
   * Mutates the object in-place for performance.
   * Hoisted function to be usable in useEffect hooks above.
   */
  function sanitizePayload(data) {
    // Enum fields: '' or undefined → null (never delete: the EDIT-mode diff
    // needs the key present to detect "cleared" and send an explicit null —
    // a deleted key becomes `undefined` in the diff, which JSON.stringify
    // then drops from the request body, so the backend never learns the
    // field should be cleared and the old value silently persists)
    enumFields.forEach((key) => {
      if (data[key] === '' || data[key] === undefined || data[key] === null) {
        data[key] = null;
      }
    });
    // Number fields: '' or undefined or null or NaN → null, otherwise cast to Number
    numberFields.forEach((key) => {
      if (data[key] === '' || data[key] === undefined || data[key] === null) {
        data[key] = null;
      } else {
        const numVal = Number(data[key]);
        data[key] = isNaN(numVal) ? null : numVal;
      }
    });
    // Date fields: '' or undefined → null
    dateFields.forEach((key) => {
      if (data[key] === '' || data[key] === undefined || data[key] === null) {
        data[key] = null;
      }
    });
    return data;
  }

  /**
   * Compute a shallow diff between two objects.
   * Returns an object containing only keys whose values changed.
   */
  const getChangedFields = (original, current) => {
    const changed = {};
    if (!original) return current; // fallback: send everything if no snapshot
    const allKeys = new Set([...Object.keys(original), ...Object.keys(current)]);
    allKeys.forEach((key) => {
      if (!_.isEqual(original[key], current[key])) {
        changed[key] = current[key];
      }
    });
    return changed;
  };

  const submitFormLogic = (values, setSubmitting) => {
    // Clone to avoid mutating Formik state
    const processed = _.cloneDeep(values);

    processed['is_active'] = !isDraft;

    // Sanitize all typed fields (enum → null, number → null/Number, date → null)
    sanitizePayload(processed);

    if (processed.operational_status === 'ComingSoon') {
      processed['charger_status'] = 'Unavailable';
      processed['operational_status'] = 'ComingSoon';
    } else if (processed.operational_status === 'UnderMaintenance') {
      processed['operational_status'] = 'UnderMaintenance';
    } else if (processed.operational_status === 'Decommissioned') {
      processed['operational_status'] = 'Decommissioned';
      processed['is_active'] = false;
      processed['is_enabled'] = false;
      processed['is_decommissioned'] = true;
      processed['decommissioned_on'] = new Date();
      if (processed.is_decommission_confirmed) {
        processed['decommissioned_by'] = processed.decommissioned_by_temp;
      }
    } else {
      processed['operational_status'] = 'Active';
      processed['is_active'] = true;
      processed['is_enabled'] = true;
      processed['decommissioned_by'] = "";
      processed['is_decommissioned'] = false;
      processed['decommissioned_on'] = null;
    }

    if (chargerId) {
      // ── EDIT mode: send only changed fields ──
      const fullData = {
        ...processed,
        chargerId: chargerId || processed.id,
        plugs: _.map(processed.plugs, (item) => _.omit(item, ['oem_ref'])),
        tarrif: processed.tariff,
      };

      // Remove read-only / server-managed fields
      const cleanData = _.omit(fullData, fieldsToOmit);

      // Compute diff against the initial snapshot
      const diffPayload = getChangedFields(initialSnapshot, cleanData);

      // Always include these keys so backend logic works correctly
      diffPayload.chargerId = chargerId || processed.id;
      if (processed.tariff) diffPayload.tarrif = processed.tariff;
      // Always include operational_status so backend can handle status transitions
      diffPayload.operational_status = processed.operational_status;
      diffPayload.is_active = processed.is_active;
      // Include plugs if they changed
      if (!_.isEqual(initialSnapshot?.plugs, cleanData.plugs)) {
        diffPayload.plugs = cleanData.plugs;
      }
      // Include maintenance fields when UnderMaintenance
      if (processed.operational_status === 'UnderMaintenance') {
        diffPayload.maintenance_type = processed.maintenance_type;
        diffPayload.maintenance_remarks = processed.maintenance_remarks;
        diffPayload.charger_status = processed.charger_status;
      }
      // Include decommission fields
      if (processed.operational_status === 'Decommissioned') {
        diffPayload.is_enabled = processed.is_enabled;
        diffPayload.is_decommissioned = processed.is_decommissioned;
        diffPayload.decommissioned_on = processed.decommissioned_on;
        diffPayload.decommissioned_by = processed.decommissioned_by;
      }

      editChargerDetail(diffPayload, () => setSubmitting(false));
    } else {
      // ── ADD mode: send full payload ──
      const chargerData = {
        ...processed,
        tarrif: processed.tariff,
        plugs: _.map(processed.plugs, (item) => _.omit(item, ['_id', 'errorCode', 'errorMessage', 'external_tarrif', 'oem_ref'])),
      };
      const addChargerData = _.omit(chargerData, ['tariff', 'oem_vendor', 'is_decommission_confirmed', 'decommissioned_by_temp']);
      addCharger(addChargerData, () => setSubmitting(false));
    }
  };

  return (
    <React.Fragment>
      <LayoutContainer>
        <AdminHeader
          title={`${chargerId ? 'Edit' : 'Add'} ${t('header.charger')}`}
          backTo={chargerId ? `/charger/${chargerId}` : '/chargerStatus'}
        />
        <div className="page-content-wrapper scrollable">
          <div className="add-charger-page__main">
            <Card className="charger-form--card">
              <Formik
                enableReinitialize={!!chargerId}
                initialValues={initialValues}
                validationSchema={ChargerSchema}
                validateOnMount={true}
                onSubmit={(values, { setSubmitting }) => {
                  if (values.operational_status === 'Decommissioned' && !values.is_decommission_confirmed) {
                    setPendingValues(values);
                    setPendingSetSubmitting(() => setSubmitting);
                    setShowDecommissionModal(true);
                    setSubmitting(false);
                    return;
                  }
                  submitFormLogic(values, setSubmitting);
                }}
              >
                {({ values, handleSubmit, handleChange, setFieldValue, isSubmitting, errors, touched, isValid }) => (
                  <Form onSubmit={handleSubmit}>
                    {(() => {
                      const selectedTypes = _.get(values, 'connectivity.connection_type', []);
                      return (
                        <>
                          <div className="tab-block" style={{ marginBottom: '20px' }}>
                            <div className="tab-nav-block">
                              <a
                                href="#"
                                className={`tab-nav__item ${activeTab === 'basic' ? 'active' : ''}`}
                                style={getTabStyle('basic', errors)}
                                onClick={(e) => {
                                  e.preventDefault();
                                  setActiveTab('basic');
                                }}
                              >
                                Basic Info & Plugs
                                {hasTabError('basic', errors) && (
                                  <span style={{ marginLeft: '5px', fontWeight: 'bold' }}>●</span>
                                )}
                              </a>
                              <a
                                href="#"
                                className={`tab-nav__item ${activeTab === 'power' ? 'active' : ''}`}
                                style={getTabStyle('power', errors)}
                                onClick={(e) => {
                                  e.preventDefault();
                                  setActiveTab('power');
                                }}
                              >
                                Power & System Info
                                {hasTabError('power', errors) && (
                                  <span style={{ marginLeft: '5px', fontWeight: 'bold' }}>●</span>
                                )}
                              </a>
                              <a
                                href="#"
                                className={`tab-nav__item ${activeTab === 'warranty' ? 'active' : ''}`}
                                style={getTabStyle('warranty', errors)}
                                onClick={(e) => {
                                  e.preventDefault();
                                  setActiveTab('warranty');
                                }}
                              >
                                Warranty & AMC
                                {hasTabError('warranty', errors) && (
                                  <span style={{ marginLeft: '5px', fontWeight: 'bold' }}>●</span>
                                )}
                              </a>
                              <a
                                href="#"
                                className={`tab-nav__item ${activeTab === 'connectivity' ? 'active' : ''}`}
                                style={getTabStyle('connectivity', errors)}
                                onClick={(e) => {
                                  e.preventDefault();
                                  setActiveTab('connectivity');
                                }}
                              >
                                Connectivity & Lifecycle
                                {hasTabError('connectivity', errors) && (
                                  <span style={{ marginLeft: '5px', fontWeight: 'bold' }}>●</span>
                                )}
                              </a>
                            </div>
                          </div>

                          {activeTab === 'basic' && (
                            <>
                              <div>
                                <SessionHeading text={t('addChargerForm.chargerInformation')} />
                                <div className="charger-form--block">
                                  <Row>
                                    <Col lg={12}>
                                      <Select
                                        isRequired
                                        label={t('addChargerForm.stationSituated')}
                                        options={_.map(allStations, (station) => {
                                          return { label: station.name, value: station.id };
                                        })}
                                        placeholder={t('placeHolder.selectStation')}
                                        name="charging_station"
                                        value={values.charging_station}
                                        onChange={(val) => setFieldValue(`charging_station`, val)}
                                        error={errors.charging_station && touched.charging_station ? errors.charging_station : null}
                                      />
                                    </Col>
                                    <Col lg={6} md={6}>
                                      <TextInput
                                        as="textarea"
                                        rows="4"
                                        inputClass="scrollable"
                                        placeholder={t('placeHolder.selectDescription')}
                                        label={t('addChargerForm.description')}
                                        name="description"
                                        value={values.description}
                                        onChange={handleChange}
                                      />
                                    </Col>
                                    <Col lg={6} md={12}>
                                      <div className="parking-checkbox-input__block">
                                        <label htmlFor="parking_restriction" className="parking--label">
                                          {t('addChargerForm.parkingRestrictions')}
                                        </label>
                                        <CheckBox
                                          name="parking_restriction"
                                          checked={values.parking_restrictions}
                                          onChange={(e) => setFieldValue('parking_restrictions', e.target.checked)}
                                        />
                                        <br />
                                        <label htmlFor="superfast_mode_supported" className="parking--label">
                                          {t('addChargerForm.superFastMode')}
                                        </label>
                                        <CheckBox
                                          name="superfast_mode_supported"
                                          checked={values.is_superfast_mode_supported}
                                          onChange={(e) => setFieldValue('is_superfast_mode_supported', e.target.checked)}
                                        />
                                        <br />
                                        <label htmlFor="duplicate_transaction_mode_supported" className="parking--label">
                                          {t('addChargerForm.duplicateTransactionMode')}
                                        </label>
                                        <CheckBox
                                          name="duplicate_transaction_mode_supported"
                                          checked={values.is_duplicate_transaction_mode_supported}
                                          onChange={(e) => setFieldValue('is_duplicate_transaction_mode_supported', e.target.checked)}
                                        />
                                        <br />
                                        <label htmlFor="auto_charge_supported" className="parking--label">
                                          {t('addChargerForm.autoChargingSupport')}
                                        </label>
                                        <CheckBox
                                          name="auto_charge_supported"
                                          checked={values.auto_charge_supported}
                                          onChange={(e) => setFieldValue('auto_charge_supported', e.target.checked)}
                                        />
                                        <br />
                                        <label htmlFor="ping_pong_supported" className="parking--label">
                                          {t('addChargerForm.pingPongSupported')}
                                        </label>
                                        <CheckBox
                                          name="ping_pong_supported"
                                          checked={values.is_ping_pong_supported}
                                          onChange={(e) => setFieldValue('is_ping_pong_supported', e.target.checked)}
                                        />
                                        <div className="otp-checkbox">
                                          <label htmlFor="otp_verification" className="parking--label">
                                            {t('addChargerForm.otp')}
                                          </label>
                                          <CheckBox
                                            name="otp_verification"
                                            checked={values.otp_verification}
                                            onChange={(e) => setFieldValue('otp_verification', e.target.checked)}
                                          />
                                          <br />
                                          <label htmlFor="rfid_verification" className="parking--label">
                                            {t('addChargerForm.rifd')}
                                          </label>
                                          <CheckBox
                                            name="rfid_verification"
                                            checked={values.rfid_verification}
                                            onChange={(e) => setFieldValue('rfid_verification', e.target.checked)}
                                          />
                                        </div>
                                        <label htmlFor="wss_supported" className="parking--label">
                                          {t('addChargerForm.wssSupported')}
                                        </label>
                                        <CheckBox
                                          name="wss_supported"
                                          checked={values.wss_supported}
                                          onChange={(e) => setFieldValue('wss_supported', e.target.checked)}
                                        />
                                        <br />
                                        <label htmlFor="load_balancing" className="parking--label">
                                          {t('addChargerForm.loadBalancing')}
                                        </label>
                                        <CheckBox
                                          name="load_balancing"
                                          checked={values.does_support_load_balancing}
                                          onChange={(e) => setFieldValue('does_support_load_balancing', e.target.checked)}
                                        />
                                        <br />
                                      </div>
                                    </Col>
                                    <Col lg={6} md={6}>
                                      <TextInput
                                        isRequired
                                        label={t('addChargerForm.chargerID')}
                                        name="charger_id"
                                        value={values.charger_id}
                                        onChange={handleChange}
                                        error={errors.charger_id && touched.charger_id ? errors.charger_id : null}
                                      />
                                    </Col>
                                    <Col lg={6} md={6}>
                                      <TextInput
                                        post_text={t('addChargerForm.mins')}
                                        label={t('addChargerForm.cooldownTime')}
                                        name="cooldown_time"
                                        value={values.cooldown_time}
                                        onChange={handleChange}
                                      />
                                    </Col>
                                    <Col lg={6} md={6}>
                                      <Row>
                                        <Col lg={12} md={12}>
                                          <Select
                                            isRequired
                                            label={t('addChargerForm.oem')}
                                            options={_.map(allOemVendor, (oemItem) => {
                                              return { label: oemItem.name, value: oemItem.id };
                                            })}
                                            placeholder={t('placeHolder.selectOEMName')}
                                            name="oem_vendor"
                                            value={values.oem_vendor}
                                            onMenuScrollDown={true}
                                            getDataOnScrollDown={getOemVendor}
                                            page={oemPage}
                                            totalPage={oemTotalPage}
                                            onChange={(val) => {
                                              getChargeSpotByOem(val);
                                              setFieldValue(`oem_vendor`, val);
                                              setFieldValue(`oem`, '');
                                              setFieldValue(`tariff`, '');
                                              setFieldValue(`plugs`, []);
                                            }}
                                            error={errors.oem_vendor && touched.oem_vendor ? errors.oem_vendor : null}
                                          />
                                        </Col>
                                      </Row>
                                    </Col>
                                    <Col lg={6} md={6}>
                                      <Row>
                                        <Col lg={12} md={12}>
                                          <Select
                                            isRequired
                                            label={t('addChargerForm.chargespotName')}
                                            options={_.map(allOems, (item) => {
                                              return { label: item.name, value: item.id };
                                            })}
                                            placeholder={t('placeHolder.selectChargeSport')}
                                            name="oem"
                                            value={values.oem}
                                            onChange={(val) => {
                                              setFieldValue(`oem`, val);
                                              setFieldValue(`tariff`, '');
                                              getTariffByChargeSpot({ oem: val, limit: 999 });
                                              const oemPlugs = _.get(_.find(allOems, { id: val }), 'plugs');
                                              if (_.isEmpty(oemPlugs)) {
                                                setFieldValue('plugs', []);
                                              } else {
                                                const plugData = _.map(oemPlugs, (item) => {
                                                  return { name: item.name, connector_id: item.number, oem_ref: item._id, status: 'Unavailable' };
                                                });
                                                setFieldValue('plugs', plugData);
                                              }
                                            }}
                                            error={errors.oem && touched.oem ? errors.oem : null}
                                          />
                                        </Col>
                                      </Row>
                                    </Col>
                                    <Col lg={6} md={12}>
                                      <Select
                                        isRequired
                                        label={t('addChargerForm.tariff')}
                                        options={_.map(allTariffList, (item) => {
                                          return { label: item.name, value: item.id };
                                        })}
                                        placeholder={t('placeHolder.selectTarrif')}
                                        name="tarrif"
                                        value={values.tariff}
                                        onMenuScrollDown={true}
                                        getDataOnScrollDown={(data) => getTariffByChargeSpot({ ...data, oem: values.oem })}
                                        page={tariffPage}
                                        totalPage={tariffTotalPage}
                                        onChange={(val) => {
                                          setFieldValue(`tariff`, val);
                                        }}
                                        error={errors.tariff && touched.tariff ? errors.tariff : null}
                                      />
                                    </Col>
                                    <Col lg={6} md={12}>
                                      <Select
                                        isRequired
                                        label={t('addChargerForm.operationalStatus')}
                                        options={[
                                          { label: 'Active', value: 'Active' },
                                          { label: 'UnderMaintenance', value: 'UnderMaintenance' },
                                          { label: 'Coming Soon', value: 'ComingSoon' },
                                          { label: 'Mark Decommissioned', value: 'Decommissioned' },
                                        ]}
                                        placeholder={t('placeHolder.operationalStatus')}
                                        name="operational_status"
                                        value={values.operational_status}
                                        onChange={(val) => {
                                          setFieldValue('operational_status', val);
                                          if (val !== 'UnderMaintenance') {
                                            setFieldValue('maintenance_type', '');
                                            setFieldValue('maintenance_remarks', '');
                                          }
                                        }}
                                        error={errors.operational_status && touched.operational_status ? errors.operational_status : null}
                                      />
                                    </Col>
                                    {(values.operational_status === 'UnderMaintenance' || values.operational_status === 'Under Maintenance') && (
                                      <Col lg={6} md={12}>
                                        <Select
                                          isRequired
                                          label="Maintenance Type"
                                          options={maintenanceTypes}
                                          placeholder="Select Maintenance Type"
                                          name="maintenance_type"
                                          value={values.maintenance_type || ''}
                                          onChange={(val) => setFieldValue('maintenance_type', val)}
                                          error={errors.maintenance_type && touched.maintenance_type ? errors.maintenance_type : null}
                                        />
                                      </Col>
                                    )}
                                    {(values.operational_status === 'UnderMaintenance' || values.operational_status === 'Under Maintenance') && (
                                      <Col lg={6} md={12}>
                                        <TextInput
                                          isRequired
                                          as="textarea"
                                          rows="4"
                                          inputClass="scrollable"
                                          placeholder="Maintenance Remarks"
                                          label="Maintenance Remarks"
                                          name="maintenance_remarks"
                                          value={values.maintenance_remarks}
                                          onChange={handleChange}
                                          error={errors.maintenance_remarks && touched.maintenance_remarks ? errors.maintenance_remarks : null}
                                        />
                                      </Col>
                                    )}
                                    <Col lg={6} md={6}>
                                      <Select
                                        isRequired
                                        label={t('addChargerForm.chargingSpeed')}
                                        options={_.map(allChargerSpeed, (item) => {
                                          return { label: item.name, value: item.id };
                                        })}
                                        placeholder={t('placeHolder.selectSpeed')}
                                        name="charging_speed"
                                        value={values.charging_speed}
                                        onChange={(val) => setFieldValue(`charging_speed`, val)}
                                        error={errors.charging_speed && touched.charging_speed ? errors.charging_speed : null}
                                      />
                                    </Col>
                                    <Col lg={6} md={6}>
                                      <DatePickerInput
                                        placeholder={t('placeHolder.selectInstallDate')}
                                        label={t('addChargerForm.installationDate')}
                                        name="installation_date"
                                        value={_.get(values, 'installation_date') || ''}
                                        onChange={(dateString) => setFieldValue('installation_date', dateString)}
                                      />
                                    </Col>
                                    <Col lg={6} md={6}>
                                      <TextInput
                                        label={t('addChargerForm.serialNumber')}
                                        name="serial_number"
                                        value={values.serial_number}
                                        onChange={handleChange}
                                      />
                                    </Col>
                                    <Col lg={6} md={6}>
                                      <TextInput label={t('addChargerForm.loadLimit')} name="load_limit" value={values.load_limit} onChange={handleChange} />
                                    </Col>
                                    <Col lg={6} md={6}>
                                      <TextInput
                                        type="number"
                                        step="any"
                                        label="Custom Rating (kWh)"
                                        name="custom_rating"
                                        value={values.custom_rating}
                                        onChange={handleChange}
                                        error={errors.custom_rating && touched.custom_rating ? errors.custom_rating : null}
                                      />
                                    </Col>
                                    {supportApp ? (
                                      <Col>
                                        <div className="parking-checkbox-input__block">
                                          <label htmlFor="is_chargecoin_disabled" className="parking--label">
                                            {t('addChargerForm.isDisableChargecoin')}
                                          </label>
                                          <CheckBox
                                            name="is_chargecoin_disabled"
                                            checked={values.is_chargecoin_disabled}
                                            onChange={(e) => setFieldValue('is_chargecoin_disabled', e.target.checked)}
                                          />
                                        </div>
                                      </Col>
                                    ) : (
                                      ''
                                    )}
                                    <Col lg={6} md={6}>
                                      <DatePickerInput
                                        placeholder={t('placeHolder.goLiveDate')}
                                        label={t('addChargerForm.goLiveDate')}
                                        name="go_live_date"
                                        value={_.get(values, 'go_live_date') || ''}
                                        onChange={(dateString) => setFieldValue('go_live_date', dateString)}
                                      />
                                    </Col>
                                    <Col lg={6} md={6}>
                                      <Select
                                        label={t('addChargerForm.ownershipType')}
                                        options={_.map(ownershipTypeList, (item) => {
                                          return { label: item.name, value: item.name };
                                        })}
                                        placeholder={t('placeHolder.ownershipType')}
                                        name="ownership_type"
                                        value={values.ownership_type}
                                        onMenuScrollDown={true}
                                        getDataOnScrollDown={getOwnershipType}
                                        page={ownershipTypePage}
                                        totalPage={ownershipTypeTotalPage}
                                        onChange={(val) => {
                                          setFieldValue(`ownership_type`, val);
                                        }}
                                        error={errors.ownership_type && touched.ownership_type ? errors.ownership_type : null}
                                      />
                                    </Col>
                                  </Row>
                                </div>
                              </div>
                              {/* â•â•â• Plugs Information â•â•â• */}
                              <div>
                                <SessionHeading text={t('addChargerForm.plugsInformation')} />
                                <div className="charger-form--block">
                                  <div className="plug-block__field-inputs">
                                    <FieldArray
                                      name="plugs"
                                      render={() => (
                                        <>
                                          {_.map(values.plugs, (field, index) => (
                                            <div className="charger-plug--item">
                                              <Row key={`charger-plug-${index}`}>
                                                <Col lg={4} md={6}>
                                                  <TextInput
                                                    disabled
                                                    label={t('addChargerForm.name')}
                                                    name="name"
                                                    value={field.name || ''}
                                                    onChange={(e) => setFieldValue(`plugs[${index}].name`, e.target.value)}
                                                  />
                                                </Col>
                                                <Col lg={4} md={6}>
                                                  <TextInput
                                                    disabled
                                                    label={t('addChargerForm.connectorId')}
                                                    name="connector_id"
                                                    value={field.connector_id || ''}
                                                    onChange={(e) => setFieldValue(`plugs[${index}].connector_id`, e.target.value)}
                                                  />
                                                </Col>
                                                <Col lg={4} md={12}>
                                                  <Select
                                                    isClearable
                                                    label={t('addChargerForm.tariff')}
                                                    options={_.map(allTariffList, (item) => {
                                                      return { label: item.name, value: item.id };
                                                    })}
                                                    placeholder={t('placeHolder.selectTarrif')}
                                                    name="tarrif"
                                                    value={field.tarrif || ''}
                                                    onMenuScrollDown={true}
                                                    getDataOnScrollDown={(data) => getTariffByChargeSpot({ ...data, oem: values.oem })}
                                                    page={tariffPage}
                                                    totalPage={tariffTotalPage}
                                                    onChange={(val) => {
                                                      setFieldValue(`plugs[${index}].tarrif`, val);
                                                    }}
                                                  />
                                                </Col>
                                              </Row>
                                            </div>
                                          ))}
                                        </>
                                      )}
                                    />
                                  </div>
                                </div>
                              </div>
                            </>
                          )}
                          {/* ═══ Charger Power & System Info ═══ */}
                          {activeTab === 'power' && (
                            <div>
                              <SessionHeading text="Charger Power & System Info" />
                              <div className="charger-form--block">
                                <Row>
                                  <Col lg={4} md={6}>
                                    <Select
                                      label="Charging System Type"
                                      options={[
                                        { label: 'STAND ALONE', value: 'STAND ALONE' },
                                        { label: 'DISPENSER', value: 'DISPENSER' },
                                        { label: 'PORTABLE', value: 'PORTABLE' },
                                        { label: 'OTHER', value: 'OTHER' },
                                      ]}
                                      placeholder="Select Charging System Type"
                                      name="charging_system_type"
                                      value={values.charging_system_type}
                                      onChange={(val) => setFieldValue('charging_system_type', val)}
                                    />
                                  </Col>
                                  <Col lg={4} md={6}>
                                    <TextInput
                                      label="OEM Charger Type"
                                      name="oem_charger_type"
                                      value={values.oem_charger_type}
                                      onChange={handleChange}
                                    />
                                  </Col>
                                  <Col lg={4} md={6}>
                                    <TextInput
                                      label="Dispenser Capacity (kW)"
                                      name="dispenser_capacity_kw"
                                      value={values.dispenser_capacity_kw}
                                      onChange={handleChange}
                                      type="number"
                                    />
                                  </Col>
                                </Row>
                                <Row className="mt-2">
                                  <Col lg={6} md={6}>
                                    <TextInput
                                      label="Output Power Limit (kW)"
                                      name="output_power_limit_kw"
                                      value={values.output_power_limit_kw}
                                      onChange={handleChange}
                                      type="number"
                                    />
                                  </Col>
                                  <Col lg={6} md={6}>
                                    <TextInput
                                      label="Power Limit (kW)"
                                      name="charger_power_limit"
                                      value={values.charger_power_limit}
                                      onChange={(e) => {
                                        const v = e.target.value;
                                        // allow empty (clearing) but block negative values
                                        if (v === '' || Number(v) >= 0) handleChange(e);
                                      }}
                                      type="number"
                                      step="any"
                                      min="0"
                                    />
                                  </Col>
                                  <Col lg={6} md={6}>
                                    <TextInput
                                      label="Onboarded On CMS By"
                                      name="onboarded_on_cms_by"
                                      value={values.onboarded_on_cms_by}
                                      onChange={handleChange}
                                    />
                                  </Col>
                                </Row>
                              </div>
                            </div>
                          )}

                          {/* ═══ Warranty Details ═══ */}
                          {activeTab === 'warranty' && (
                            <>
                              <div>
                                <SessionHeading text="Warranty Details" />
                                <div className="charger-form--block">
                                  <Row>
                                    <Col lg={4} md={6}>
                                      <TextInput
                                        type="number"
                                        label="Warranty Period (Years)"
                                        name="warranty_period_years"
                                        value={values.warranty_period_years}
                                        onChange={handleChange}
                                      />
                                    </Col>
                                    <Col lg={4} md={6}>
                                      <DatePickerInput
                                        placeholder="Select Warranty Expiry Date"
                                        label="Warranty Expired Date"
                                        name="warranty_expired_date"
                                        value={_.get(values, 'warranty_expired_date') || ''}
                                        onChange={(dateString) => setFieldValue('warranty_expired_date', dateString)}
                                      />
                                    </Col>
                                    <Col lg={4} md={6}>
                                      <Select
                                        label="Warranty Status"
                                        options={[
                                          { label: 'Active', value: 'Active' },
                                          { label: 'Expired', value: 'Expired' },
                                          { label: 'NA', value: 'NA' },
                                        ]}
                                        placeholder="Select Status"
                                        name="warranty_status"
                                        value={values.warranty_status}
                                        onChange={(val) => setFieldValue('warranty_status', val)}
                                      />
                                    </Col>
                                  </Row>
                                </div>
                              </div>
                              {/* ═══ AMC (Maintenance) ═══ */}
                              <div>
                                <SessionHeading text="AMC (Maintenance)" />
                                <div className="charger-form--block">
                                  <Row>
                                    <Col lg={3} md={6}>
                                      <DatePickerInput
                                        placeholder="Select AMC Start Date"
                                        label="AMC Start Date"
                                        name="amc_start_date"
                                        value={_.get(values, 'amc_start_date') || ''}
                                        onChange={(dateString) => setFieldValue('amc_start_date', dateString)}
                                      />
                                    </Col>
                                    <Col lg={3} md={6}>
                                      <TextInput
                                        type="number"
                                        label="AMC Done Period (Years)"
                                        name="amc_done_period_years"
                                        value={values.amc_done_period_years}
                                        onChange={handleChange}
                                      />
                                    </Col>
                                    <Col lg={3} md={6}>
                                      <DatePickerInput
                                        placeholder="Select AMC Expiry Date"
                                        label="AMC Expired Date"
                                        name="amc_expired_date"
                                        value={_.get(values, 'amc_expired_date') || ''}
                                        onChange={(dateString) => setFieldValue('amc_expired_date', dateString)}
                                      />
                                    </Col>
                                    <Col lg={3} md={6}>
                                      <Select
                                        label="AMC Status"
                                        options={[
                                          { label: 'Active', value: 'Active' },
                                          { label: 'Expired', value: 'Expired' },
                                          { label: 'NA', value: 'NA' },
                                        ]}
                                        placeholder="Select Status"
                                        name="amc_status"
                                        value={values.amc_status}
                                        onChange={(val) => setFieldValue('amc_status', val)}
                                      />
                                    </Col>
                                  </Row>
                                </div>
                              </div>
                            </>
                          )}

                          {/* ═══ Connectivity Configuration ═══ */}
                          {activeTab === 'connectivity' && (
                            <>
                              <div>
                                <SessionHeading text="Connectivity Configuration" />
                                <div className="charger-form--block">
                                  <div className="form-label mb-3">Connection Types (Select multiple if supported)</div>
                                  <div className="conn-type-grid mb-4">
                                    {[
                                      { label: 'SIM', value: 'SIM', icon: <IoCellular /> },
                                      { label: 'Dual SIM', value: 'Dual SIM', icon: <IoCellular /> },
                                      { label: 'LAN', value: 'LAN', icon: <IoServer /> },
                                      { label: 'WiFi', value: 'WiFi', icon: <IoWifi /> },
                                      { label: 'ILL / Broadband', value: 'ILL', icon: <IoGlobe /> },
                                      { label: 'VSAT', value: 'VSAT', icon: <MdOutlineSatelliteAlt /> },
                                    ].map((item) => {
                                      const selectedTypes = _.get(values, 'connectivity.connection_type', []);
                                      const isActive = selectedTypes.includes(item.value);
                                      return (
                                        <div
                                          key={item.value}
                                          className={`conn-type-card ${isActive ? 'conn-type-card--active' : ''}`}
                                          onClick={() => {
                                            let newTypes = [...selectedTypes];
                                            if (isActive) {
                                              newTypes = newTypes.filter((t) => t !== item.value);
                                            } else {
                                              // Mutual exclusion for SIM / Dual SIM
                                              if (item.value === 'SIM') {
                                                newTypes = newTypes.filter((t) => t !== 'Dual SIM');
                                              } else if (item.value === 'Dual SIM') {
                                                newTypes = newTypes.filter((t) => t !== 'SIM');
                                              }
                                              newTypes.push(item.value);
                                            }
                                            setFieldValue('connectivity.connection_type', newTypes);

                                            // Manage SIM initialization
                                            const hasSIM = newTypes.includes('SIM');
                                            const hasDualSIM = newTypes.includes('Dual SIM');
                                            if (hasDualSIM) {
                                              setFieldValue('connectivity.sim', [
                                                { label: 'SIM 1', network_provider: '', sim_type: '', sim_number: '' },
                                                { label: 'SIM 2', network_provider: '', sim_type: '', sim_number: '' },
                                              ]);
                                            } else if (hasSIM) {
                                              setFieldValue('connectivity.sim', [{ label: 'SIM 1', network_provider: '', sim_type: '', sim_number: '' }]);
                                            } else {
                                              setFieldValue('connectivity.sim', []);
                                            }
                                          }}
                                        >
                                          <div className="conn-type-card__icon">{item.icon}</div>
                                          <div className="conn-type-card__label">{item.label}</div>
                                        </div>
                                      );
                                    })}
                                  </div>
                                  {(selectedTypes.includes('SIM') || selectedTypes.includes('Dual SIM')) && (
                                    <div className="mt-3">
                                      {selectedTypes.includes('SIM') && !selectedTypes.includes('Dual SIM') && (
                                        <Row className="mb-2">
                                          <Col lg={6} md={6}>
                                            <div className="parking-checkbox-input__block">
                                              <label htmlFor="supports_dual_sim" className="parking--label">Charger Supports Dual SIM?</label>
                                              <CheckBox
                                                name="connectivity.supports_dual_sim"
                                                checked={_.get(values, 'connectivity.supports_dual_sim', false)}
                                                onChange={(e) => setFieldValue('connectivity.supports_dual_sim', e.target.checked)}
                                              />
                                            </div>
                                          </Col>
                                        </Row>
                                      )}
                                      <FieldArray
                                        name="connectivity.sim"
                                        render={() => (
                                          <>
                                            {_.map(_.get(values, 'connectivity.sim', []), (sim, idx) => (
                                              <div key={`sim-entry-${idx}`} className="charger-plug--item mb-3">
                                                <h6 className="mb-2" style={{ color: '#8b9dc3', fontWeight: 600 }}>{sim.label || `SIM ${idx + 1}`}</h6>
                                                <Row>
                                                  <Col lg={4} md={6}>
                                                    <Select
                                                      label="Network Provider"
                                                      options={[
                                                        { label: 'Airtel', value: 'Airtel' },
                                                        { label: 'Jio', value: 'Jio' },
                                                        { label: 'VI', value: 'VI' },
                                                        { label: 'BSNL', value: 'BSNL' },
                                                      ]}
                                                      placeholder="Select Provider"
                                                      name={`connectivity.sim[${idx}].network_provider`}
                                                      value={sim.network_provider || ''}
                                                      onChange={(val) => setFieldValue(`connectivity.sim[${idx}].network_provider`, val)}
                                                    />
                                                  </Col>
                                                  <Col lg={4} md={6}>
                                                    <Select
                                                      label="SIM Type"
                                                      options={[
                                                        { label: 'M2M', value: 'M2M' },
                                                        { label: 'Voice', value: 'Voice' },
                                                      ]}
                                                      placeholder="Select SIM Type"
                                                      name={`connectivity.sim[${idx}].sim_type`}
                                                      value={sim.sim_type || ''}
                                                      onChange={(val) => setFieldValue(`connectivity.sim[${idx}].sim_type`, val)}
                                                    />
                                                  </Col>
                                                  <Col lg={4} md={6}>
                                                    <TextInput
                                                      label="SIM Number"
                                                      name={`connectivity.sim[${idx}].sim_number`}
                                                      value={sim.sim_number || ''}
                                                      onChange={handleChange}
                                                    />
                                                  </Col>
                                                </Row>
                                              </div>
                                            ))}
                                          </>
                                        )}
                                      />
                                    </div>
                                  )}
                                  {selectedTypes.includes('WiFi') && (
                                    <div className="mt-3">
                                      <h6>WiFi Configuration</h6>
                                      <Row className="mt-2">
                                        <Col lg={6} md={6}>
                                          <TextInput label="SSID" name="connectivity.wifi.ssid" value={_.get(values, 'connectivity.wifi.ssid', '')} onChange={handleChange} />
                                        </Col>
                                        <Col lg={6} md={6}>
                                          <TextInput label="Password" name="connectivity.wifi.password" value={_.get(values, 'connectivity.wifi.password', '')} onChange={handleChange} />
                                        </Col>
                                      </Row>
                                    </div>
                                  )}
                                  {selectedTypes.includes('ILL') && (
                                    <div className="mt-3">
                                      <h6>ILL / Broadband Configuration</h6>
                                      <Row className="mt-2">
                                        <Col lg={4} md={6}>
                                          <TextInput label="Network Provider" name="connectivity.broadband.network_provider" value={_.get(values, 'connectivity.broadband.network_provider', '')} onChange={handleChange} />
                                        </Col>
                                        <Col lg={4} md={6}>
                                          <TextInput label="SSID" name="connectivity.broadband.ssid" value={_.get(values, 'connectivity.broadband.ssid', '')} onChange={handleChange} />
                                        </Col>
                                        <Col lg={4} md={6}>
                                          <TextInput label="Password" name="connectivity.broadband.password" value={_.get(values, 'connectivity.broadband.password', '')} onChange={handleChange} />
                                        </Col>
                                      </Row>
                                    </div>
                                  )}
                                  {selectedTypes.includes('LAN') && (
                                    <div className="mt-3">
                                      <h6>LAN Configuration</h6>
                                      <Row className="mt-2">
                                        <Col lg={6} md={6}>
                                          <Select label="IP Configuration" options={[{ label: 'DHCP', value: 'DHCP' }, { label: 'Static IP', value: 'Static IP' }]} placeholder="Select IP Config" name="connectivity.lan.ip_config" value={_.get(values, 'connectivity.lan.ip_config', '')} onChange={(val) => setFieldValue('connectivity.lan.ip_config', val)} />
                                        </Col>
                                      </Row>
                                    </div>
                                  )}
                                  {selectedTypes.includes('VSAT') && (
                                    <div className="mt-3">
                                      <h6>VSAT Configuration</h6>
                                      <Row className="mt-2">
                                        <Col lg={6} md={6}>
                                          <TextInput label="Provider" name="connectivity.vsat.provider" value={_.get(values, 'connectivity.vsat.provider', '')} onChange={handleChange} />
                                        </Col>
                                        <Col lg={6} md={6}>
                                          <TextInput label="Terminal ID" name="connectivity.vsat.terminal_id" value={_.get(values, 'connectivity.vsat.terminal_id', '')} onChange={handleChange} />
                                        </Col>
                                      </Row>
                                    </div>
                                  )}
                                </div>
                              </div>
                              {/* â•â•â• Lifecycle / Decommissioning â•â•â• */}
                              <div>
                                <SessionHeading text="Lifecycle / Decommissioning" />
                                <div className="charger-form--block">
                                  <Row>
                                    <Col lg={6} md={6}>
                                      <DatePickerInput placeholder="Select Decommission Date" label="Decommissioned On" name="decommissioned_on" value={_.get(values, 'decommissioned_on') || ''} onChange={(dateString) => setFieldValue('decommissioned_on', dateString)} />
                                    </Col>
                                    <Col lg={6} md={6}>
                                      <TextInput label="Decommissioned By" name="decommissioned_by" value={values.decommissioned_by} onChange={handleChange} />
                                    </Col>
                                  </Row>
                                </div>
                              </div>
                              <div>
                                <SessionHeading text={t('addChargerForm.comments/Notes')} />
                                <div className="charger-form--block">
                                  <Row>
                                    <Col>
                                      <TextInput as="textarea" rows="6" inputClass="scrollable" label={t('addChargerForm.commentsforChargingStation')} name="comments" value={values.comments} onChange={handleChange} />
                                    </Col>
                                  </Row>
                                </div>
                              </div>
                            </>
                          )}
                          {!_.isEmpty(manageAddOns) ||
                            (!_.isEmpty(getAddOns) && !_.isEmpty(manageAddOns)) ||
                            !_.isEmpty(manageStationCharger) ||
                            (!_.isEmpty(getStationCharger) && !_.isEmpty(manageStationCharger)) ? (
                            <div className="save-draft-btn--block">
                              <Button
                                type="submit"
                                className="save-btn draft--btn"
                                disabled={isSubmitting}
                                onClick={() => {
                                  setDraft(true);
                                  if (!isValid) {
                                    toast.error('please fill all required fields');
                                  }
                                }}
                              >
                                {isSubmitting && isDraft && <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="mr-2" />}
                                {t('button.saveDraft')}
                              </Button>
                              <Button
                                type="submit"
                                className="save-btn"
                                disabled={isSubmitting}
                                onClick={() => {
                                  setDraft(false);
                                  if (!isValid) {
                                    toast.error('please fill all required fields');
                                  }
                                }}
                              >
                                {isSubmitting && !isDraft && <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="mr-2" />}
                                {t('button.savePublish')}
                              </Button>
                            </div>
                          ) : (
                            <div className="save-draft-btn--block">
                              <Button className="save-btn draft--btn"> {t('button.saveDraft')}</Button>
                              <Button className="save-btn"> {t('button.savePublish')}</Button>
                            </div>
                          )}
                        </>
                      );
                    })()}
                  </Form>
                )}
              </Formik>
            </Card>
          </div>
          {currentUserName === 'CZ Tenant Admin' ? null : <Footer />}
        </div>
        {showDecommissionModal && (
          <Modal show={showDecommissionModal} centered onHide={() => setShowDecommissionModal(false)}>
            <div className="maintenance-modal--main" style={{ padding: '20px' }}>
              <Card>
                <div
                  className="maintenance-modal__header"
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '20px',
                    paddingBottom: '10px',
                    borderBottom: '1px solid #eee',
                  }}
                >
                  <h4 style={{ margin: 0 }}>Decommission Charger</h4>
                  <button onClick={() => setShowDecommissionModal(false)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '20px' }}>&times;</button>
                </div>
                <div className="maintenance-modal__body" style={{ marginBottom: '20px' }}>
                  <TextInput
                    label="Decommissioned By"
                    name="decommissioned_by_text"
                    value={decommissionedByText}
                    onChange={(e) => setDecommissionedByText(e.target.value)}
                    placeholder="Enter name"
                  />
                </div>
                <div
                  className="maintenance-modal__footer"
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    gap: '10px',
                    paddingTop: '10px',
                    borderTop: '1px solid #eee',
                  }}
                >
                  <Button className="btn-secondary" onClick={() => setShowDecommissionModal(false)} style={{ marginRight: '10px' }}>
                    Cancel
                  </Button>
                  <Button
                    className="btn-primary"
                    onClick={() => {
                      if (pendingValues && pendingSetSubmitting) {
                        pendingValues.is_decommission_confirmed = true;
                        pendingValues.decommissioned_by_temp = decommissionedByText;
                        setShowDecommissionModal(false);
                        pendingSetSubmitting(true);
                        submitFormLogic(pendingValues, pendingSetSubmitting);
                      }
                    }}
                  >
                    OK
                  </Button>
                </div>
              </Card>
            </div>
          </Modal>
        )}
      </LayoutContainer>
    </React.Fragment>
  );
};

export default ChargerForm;